<template>
  <div class="functionManagement" style="height: calc(100% - 10px)">
    <el-container class="functionManagement-box">
      <el-aside :class="{noboder: treeData.length === 0}">
        <el-scrollbar style="height: 100%;width: auto;">
          <tree :treeData="treeData" @getResourceList="getResourceList" :functionId="queryParams.functionId" @add="add" @edit="edit" @updateFunction="updateFunction" />
        </el-scrollbar>
      </el-aside>
      <el-container v-if="queryParams.functionId">
        <el-header :class=" queryParams.functionId === '0'? 'no-border-bottom' : ''">
          <add :show="bAddShow" :functionId="queryParams.functionId" @close="bAddShow = false" @getAllFunctionList="getAllFunctionList" />
          <edit-dialog :data="aDataDetail" :show="bShowEditDialog" @close="bShowEditDialog = false" @getAllFunctionList="getAllFunctionList" />
        </el-header>
        <el-main v-if="queryParams.functionId !== '0'">
          <div class="operation-bar">
            <el-row class="operation-box">
              <el-button size="small" type="default" icon="el-hg-icon-add" v-permission="'0501'" @click="getResourceData">新增</el-button>
              <el-button size="small" type="danger" icon="el-hg-icon-delete" @click="deleteResource()">删除</el-button>
              <el-button type="primary" size="small" icon="el-hg-icon-refreash"  @click="refresh">刷新</el-button>
            </el-row>
          </div>

          <el-scrollbar style="height: calc( 100% - 40px);width: auto;">
            <list :dataList.sync="aDataList" :functionType="queryParams.type" />
          </el-scrollbar>
        </el-main>
      </el-container>
      <resource-select :show="bSelectShow" :resourceList="resourceList" @close="bSelectShow = false" @getResourceData="getResourceData" @refresh="refresh" :functionType="queryParams.type"></resource-select>
    </el-container>
    <div class="clear"></div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import tree from './tree';
import list from './list';
import add from './actions/add';
import editDialog from './actions/edit';
import resourceSelect from './actions/resource';

export default {
  name: 'functionManagement',
  components: {
    tree,
    list,
    add,
    editDialog,
    resourceSelect
  },
  data() {
    return {
      queryParams: {
        functionId: '',
        checked: '1',
        type: 1
      },
      aDataDetail: {
        id: '',
        code: '',
        name: '',
        sort: '',
        iconClass: '',
        type: '1',
        path: '',
        closeStatus: '0',
        parentId: ''
      },
      aDataList: [],
      bAddShow: false,
      bSelectShow: false,
      resourceList: [],
      oActiveItem: {
        id: 0,
        name: ''
      },
      bShowEditDialog: false,
      treeData: []
    };
  },
  computed: {
    selected() {
      let ids = [];
      let textInfo = [];
      this.aDataList.forEach(data => {
        if (data.checked) {
          ids.push(data.id);
          textInfo.push(data.name);
        }
      });
      return {
        ids,
        textInfo
      };
    }
  },
  methods: {
    ...mapActions({
      setMenuData: 'user/setMenuData'
    }),
    async updateFunction(params) {
      let content = params.state === 1 ? '启用' : '停用';
      this.$confirm(
        `此操作将${content}功能<span style="color:red;padding:0 4px;"> ${
          params.data.label
        } </span>, 是否继续?`,
        '提示',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$services
            .post({
              type: 'FUNCTIONMANGEMENT',
              url: 'updateFunctionStatus',
              params: {
                ids: JSON.stringify([{ value: params.data.id }]),
                state: params.state
              }
            })
            .then(res => {
              if (res.code === '000') {
                this.$toaster.ok(`${content}成功`);
                this.getAllFunctionList();
              }
              else {
                this.$toaster.ok(`${content}失败`);
              }
            });
        })
        .catch(() => { });
    },
    edit(functionId) {
      this.bAddShow = false;
      if (functionId === '0') {
        this.bShowEditDialog = false;
      }
      else {
        this.getFunctionDetail();
      }
    },
    async getAllFunctionList() {
      const res = await this.$services.postLoading({
        type: 'FUNCTIONMANGEMENT',
        url: 'getFunctionList'
      });
      let treeData = [
        {
          label: '分析评估系统',
          id: '0',
          type: 1,
          children: []
        }
      ];
      treeData[0].children = res.bean;
      if (
        this.queryParams.functionId === 0
        || this.queryParams.functionId === ''
      ) {
        if (res.bean.length > 0) {
          if (res.bean[0].children.length > 0) {
            this.queryParams.functionId = res.bean[0].children[0].id;
            this.queryParams.type = res.bean[0].children[0].type;
          }
          else {
            this.queryParams.functionId = res.bean[0].id;
            this.queryParams.type = res.bean[0].type;
          }
        }
        else {
          this.queryParams.functionId = 0;
          this.queryParams.type = 1;
        }
        this.getFunctionDetail();
        this.getResourceList();
      }
      this.treeData = treeData;
      this.setMenuData();
    },
    async getFunctionDetail() {
      if (this.queryParams.functionId === '') {
        return;
      }
      const res = await this.$services.postLoading({
        type: 'FUNCTIONMANGEMENT',
        url: 'getFunctionDetail',
        params: { id: this.queryParams.functionId }
      });
      if (res.bean) {
        this.aDataDetail = res.bean;
        this.aDataDetail.closeStatus = this.aDataDetail.closeStatus === 1;
        this.aDataDetail.type = this.aDataDetail.type.toString();
      }
      this.bShowEditDialog = true;
    },
    add() {
      this.bShowEditDialog = false;
      this.bAddShow = true;
    },
    getResourceData(params) {
      // 选择资源库
      let queryParams = {};
      queryParams.functionId = this.queryParams.functionId;
      queryParams.name = '';
      queryParams.checked = '0';
      if (params.name) {
        queryParams.name = params.name;
      }
      this.$services
        .postLoading({
          type: 'RESOURCEMANGEMENT',
          url: 'getResourceList',
          params: queryParams
        })
        .then(res => {
          if (res.code === '000') {
            this.resourceList = res.bean;
          }
        });
      this.bSelectShow = true;
    },
    async getResourceList(params) {
      if (params) {
        Object.assign(this.queryParams, this.queryParams, params);
      }
      if (this.queryParams.functionId === '') {
        return;
      }
      const res = await this.$services.postLoading({
        type: 'RESOURCEMANGEMENT',
        url: 'getResourceList',
        params: this.queryParams
      });
      this.aDataList = res.bean;
    },
    refresh() {
      this.getResourceList();
    },
    async deleteResource() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一个资源');
        return;
      }
      this.$confirm(
        `此操作将删除资源<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(
          ','
        )} </span>, 是否继续?`,
        '提示',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$services
            .postJson({
              type: 'RESOURCEMANGEMENT',
              url: 'updateResource',
              params: {
                ids: this.selected.ids.join(','),
                checked: '0'
              }
            })
            .then(res => {
              if (res.code === '000') {
                this.$toaster.ok('删除成功');
                this.refresh();
              }
              else {
                this.$toaster.error(res.msg);
              }
            });
        })
        .catch(() => { });
    }
  },
  created() {
    this.getAllFunctionList();
  }
};
</script>
<style lang="scss">
.functionManagement {
  width: 100%;

  .functionManagement-box {
    // border: 1px solid #eee;
    // box-shadow: 0px 0px 10px #eee;
    border-radius: 5px;

    .el-aside.noboder {
      border-right: none;
    }

    .el-aside {
      width: auto !important;
      padding: 10px 10px 20px 10px;
      overflow: auto;
      margin-right: 10px;
      .el-scrollbar {
        .el-scrollbar__wrap {
          margin: 0;
          overflow-x: hidden !important;
        }
      }
    }

    .el-header {
      height: auto !important;
      padding: 10px 0;
      box-sizing: border-box;
      word-wrap: break-word;
      .el-form-item {
        margin-bottom: 0;
      }
    }
    .operation-bar {
      margin-bottom: 0;
    }
    .no-border-bottom {
      border-bottom: none;
    }
  }
}
</style>
